<template>
  <div class="centered-containerlogin">
    <v-card class="elevation-3">
      <div class="title">
        <img src="/scrapingant-logo.png" />
        <div class="cardTitle">Email confirmation</div>
        <div
          v-if="loading && !confirmed"
          class="md-body-1 confirmation-message xs--text fontweight400"
        >
          Confirming your email...
        </div>
        <div
          v-if="!loading && confirmed"
          class="cardBody xs--text fontweight400 confirmation-message"
        >
          Email confirmed successfully. Redirecting to dashboard...
        </div>
        <div
          v-if="error"
          class="form-error xs--text fontweight400 line-height15"
          style="margin-top: 10px"
        >
          Wrong confirmation token. Try to
          <router-link :to="{ name: 'Login' }">Login</router-link>
          for resending confirmation token.
        </div>
      </div>

      <div class="loading-overlay" v-if="loading">
        <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "EmailConfirmed",
  data() {
    return {
      loading: false,
      confirmed: false,
      error: false,
    };
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("email_confirmed/confirm_email", this.$route.params.token)
      .then(
        () => {
          this.loading = false;
          this.confirmed = true;
          this.$router.replace({ name: "Dashboard" });
        },
        (res) => {
          this.loading = false;
          this.error = true;
          this.errors(res.response);
        }
      );
  },
};
</script>

<style scoped lang="scss">
.cardTitle {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.005em;
  line-height: 26px;
}
.cardBody {
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
}
</style>